import React, { useState } from "react";
import "./addressCard.scss";
import addressStore from "../../store/addressStore";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

const AddressCard = ({
  nextStep,
  isDeliverBtn,
  isEditBtn,
  onEditClick,
  item,
}) => {
  const AddressStore = addressStore();
  const [isDelete, setIsDelete] = useState(false);
  const deliverToThisAddress = async () => {
    await AddressStore.setSelectedAddress({ selectedAddress: item });
    nextStep();
  };
  const [isOpenDialog, setIsOpenDialog] = useState(false);

  const onDialogClose = () => {
    if (!isDelete) setIsOpenDialog(false);
  };
  return (
    <div className="address-card">
      <Dialog
        fullWidth
        maxWidth="xs"
        open={isOpenDialog}
        onClose={onDialogClose}
      >
        <DialogTitle>WARNING !</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ fontFamily: "Ysabeau Office" }}>
            Are you sure want to delete <b>{item.fullName}</b> address.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ color: "#000", fontWeight: 600 }}
            disabled={isDelete}
            onClick={onDialogClose}
          >
            <p>Cancel</p>
          </Button>
          <LoadingButton
            variant="contained"
            color="error"
            loading={isDelete}
            sx={{ fontWeight: 600 }}
            onClick={async () => {
              setIsDelete(true);
              await AddressStore.removeUserAddress({ _id: item._id });
              setIsDelete(false);
              setIsOpenDialog(false);
            }}
          >
            <p>Delete</p>
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <div className="main-title">
        <div className="customer-name">{item.fullName}</div>
        <div className="address-category">({item.addressCategory})</div>
        {item.useDefault && <div className="default-address">Default</div>}
      </div>
      <div className="customer-address">
        {item.address}, {item.city} - {item.pincode} <br />
        {item.state}, {item.country}
      </div>
      <div className="contact-no-and-btn">
        <p>{item.phoneNumber}</p>
        <div className="delete-delivery-edit-btn-container">
          <div className="delete-address-btn">
            <Button className="btn" onClick={() => setIsOpenDialog(true)}>
              <p>Delete</p>
            </Button>
          </div>
          {isDeliverBtn && (
            <div className="deliver-address-btn">
              <Button
                className="btn"
                variant="outlined"
                onClick={deliverToThisAddress}
              >
                <p>Deliver to this Address</p>
              </Button>
            </div>
          )}
          {isEditBtn && (
            <div className="edit-address-btn">
              <Button className="btn" variant="outlined" onClick={onEditClick}>
                <p>Edit</p>
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddressCard;
